module.exports = __webpack_public_path__ + "img/B805.a9535f5e.jpg";